






























































































import { Vue, Component } from 'vue-property-decorator';

import featureImage1 from '@/assets/images/feature_1.svg';
import featureImage2 from '@/assets/images/feature_2.svg';
import featureImage3 from '@/assets/images/feature_3.svg';
import featureImage5 from '@/assets/images/feature_5.svg';

@Component({
  name: 'FeaturesSection',
  components: {
  },
})
/**
 * @vuese
 * @group Page/FeaturesSection
 * FeaturesSection component
 */
export default class FeaturesSection extends Vue {
  // [data]
  featureImage1: string = featureImage1;
  featureImage2: string = featureImage2;
  featureImage3: string = featureImage3;
  featureImage5: string = featureImage5;
}
